import { render, staticRenderFns } from "./UseClauses.vue?vue&type=template&id=8d079ff2&scoped=true&"
import script from "./UseClauses.vue?vue&type=script&lang=js&"
export * from "./UseClauses.vue?vue&type=script&lang=js&"
import style0 from "./UseClauses.vue?vue&type=style&index=0&id=8d079ff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d079ff2",
  null
  
)

export default component.exports